module.exports = __webpack_public_path__ + "08c15882317b0b3c4b3871c08aa63416.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/oops-page.png
// module id = 188
// module chunks = 0